import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  InputBase,
  Select,
  MenuItem,
  Stack,
  Pagination,
} from "@mui/material";
import { MdVisibility } from "react-icons/md";
import { MdModeEdit, MdDelete } from "react-icons/md";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Product = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [page, setPage] = useState(1);
  const itemsPerPage = 10;
  const navigate = useNavigate();

  // Fetch Products
  const fetchProducts = async () => {
    try {
      const res = await axios.get(
        "https://ecom-api.applligentdemo.com/product/getProduct",
        {
          headers: {
            Authorization: ` ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = res.data.products;
      setProducts(data);
      //alert(data);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleStatusToggle = (id) => {
    setProducts((prev) =>
      prev.map((product) =>
        product._id === id ? { ...product, status: !product.status } : product
      )
    );
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      console.log(id);
      try {
        await axios.delete(
          `https://ecom-api.applligentdemo.com/product/deleteProduct/${id}`,
          {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
            },
          }
        );
        fetchProducts();
        toast.success("Product Delete Successfull");
      } catch (error) {
        console.error("Error deleting product:", error);
      }
    }
  };

  const filtered = products.filter(
    (product) =>
      (statusFilter === "" || product.status === (statusFilter === "Active")) &&
      (search === "" ||
        product.name.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <Box>
      <Box p={3}>
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Box display="flex" gap={2}>
            <Box
              display="flex"
              alignItems="center"
              bgcolor="#f1f1f1"
              px={2}
              borderRadius={1}
            >
              <SearchIcon />
              <InputBase
                placeholder="Search by product name"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </Box>
            <Select
              value={statusFilter}
              displayEmpty
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <MenuItem value="">All Status</MenuItem>
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Inactive">Inactive</MenuItem>
            </Select>
          </Box>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/add-product")}
          >
            + Add Product
          </Button>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>Image</TableCell>
                <TableCell>Product Name</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered
                .slice((page - 1) * itemsPerPage, page * itemsPerPage)
                .map((product, index) => (
                  <TableRow key={product._id}>
                    <TableCell>
                      {(page - 1) * itemsPerPage + index + 1}
                    </TableCell>
                    <TableCell>
                      <img
                        src={product.image[0]}
                        alt="product"
                        width={60}
                        height={60}
                        style={{ objectFit: "cover" }}
                        // onError={(e) => (e.target.src = "https://via.placeholder.com/60")}
                      />
                    </TableCell>
                    <TableCell>{product.name}</TableCell>
                    <TableCell>{product.category.name}</TableCell>
                    <TableCell>
                      {product.description?.substring(0, 40)}...
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        color={product.status ? "success" : "secondary"}
                        onClick={() => handleStatusToggle(product._id)}
                      >
                        {product.status ? "Active" : "Inactive"}
                      </Button>
                    </TableCell>
                    <TableCell>
                      <IconButton
                        color="info"
                        onClick={() => navigate(`/product/view/${product._id}`)}
                      >
                        <MdVisibility />
                      </IconButton>
                      <IconButton color="primary">
                        <MdModeEdit
                          onClick={() =>
                            navigate(`/edit-product/${product._id}`)
                          }
                        />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() => handleDelete(product._id)}
                      >
                        <MdDelete />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Stack alignItems="center" mt={3}>
          <Pagination
            count={Math.ceil(filtered.length / itemsPerPage)}
            page={page}
            onChange={(e, val) => setPage(val)}
          />
        </Stack>
      </Box>
    </Box>
  );
};

export default Product;
